import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../assets/svg/anl-satisfaction.svg',
})
export class AnlSatisfactionComponent {}
